<table>
  <tr>
    <td class="cell-value">
      {{viewModel().avgWeight}}
    </td>
    @if (!isStatusCompleted(viewModel().status) && viewModel().avgWeight != null) {
      <td (click)="clickApprove()" class="cell-approve-reject">
        <mat-icon class="icon-action-approve cell-action-green">check_circle_outline</mat-icon>
      </td>
      <td (click)="clickReject()" class="cell-approve-reject">
        <mat-icon class="icon-action-reject cell-action-red">cancel</mat-icon>
      </td>
    }
  </tr>
</table>

